<template>
    <div class="contentMain">
        <el-dialog title="导入名单" center :visible.sync="dialogVisible" width="480px">
            <el-row :gutter="24">
                <!--下面部分-->
                <div class="sponsorBottom">
                    <el-form ref="form" :model="form" label-width="70px" class="demo-ruleForm formSheet addListForm">
                        <el-form-item label="上传文件" prop="name" class="inputFileMain">
                            <!--<el-input @change="fileData" ref="inputer" placeholder="点击上传Excel文件..."></el-input>-->
                            <el-input @change="fileData" ref="inputer" placeholder="点击上传Excel文件..." v-model="name"></el-input>
                            <!--<input class="downloadBtn" type="file" @click="show()"/>-->
                            <input type="file" class="face" @change="fileData" ref="inputer">
                            <a @click="downLoad" style="cursor: pointer">下载Excel模板</a>
                        </el-form-item>

                        <el-form-item label="上传须知" prop="name" class="inputFileMain marginTop" style="margin-top: 20px">
                            <div class="upload_wrap">
                                <p>1.上传文件必须未下载的Excel模版文件。</p>
                                <p>2.姓名为必填，内容不能包含空格。</p>
                            </div>
                        </el-form-item>
                        <el-form-item class="sureBtn">
                            <el-button type="primary" class="cancel" @click="cancel">取消</el-button>
                            <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import {downloadSignList,importSignData} from 'api/signApi'
    import {mapActions} from 'vuex'
    export default {
        data(){
            return{
                form:{},
                importexcel:{}, // 签到名单导入
                dialogVisible:false,
                name:''
            }
        },
        methods:{
            open(){
                this.dialogVisible=true
                this.importexcel = ''
                this.name = ''
            },
            cancel(){
                this.dialogVisible=false
            },
            // 下载模板
            downLoad(){
                this.setLoading(true);
                downloadSignList({
                    data: Object.assign({}, this.params),
                    success: data => {
                        console.log(data)
                        this.setLoading(false)
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '名单导入模板.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.$message.success('下载成功')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 名单导入
            submitForm(){
                this.setLoading(true);
                let formData = new FormData()
                formData.append('importexcel', this.importexcel)
                importSignData({
                    data:formData,
                    success: data => {
                        console.log(data)
                        this.dialogVisible = false
                        this.$emit('getList');
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            fileData(){
                let that = this,
                 inputDOM = that.$refs.inputer,
                 file = inputDOM.files
                this.importexcel = file[0]
                this.name = file[0].name
            },
            ...mapActions([
                'setLoading',
            ])
        }
    }
</script>

<style lang="scss">
    .contentMain{
        .inputFileMain{
            .face{
                position: absolute;
                left: 0;
                opacity: 0;
                cursor: pointer;
            }
            .downloadBtn{
                width: 180px;
                height: 35px;
                position: absolute;
                top: 0;
                left: 20px;
                opacity: 0;
            }
            a{
                position: absolute;
                left: 220px;
                top: 2px;
                color: #2b82ef;
                text-decoration: underline;
            }
            .el-form-item.is-error .el-input__inner{
                border-color: #2b82ef;
            }
            .el-input__inner::-webkit-input-placeholder {
                color: #2b82ef;
            }
            .upload_wrap{
                margin-top: 8px;
                p{
                    color: #999!important;
                }
            }
        }
        .inputFileMain .el-input__inner{
            width: 180px;
            border: 1px solid #2b82ef;
            border-radius: 20px;
            text-align: center;
            color: #2b82ef;
        }
        .marginTop .el-form-item__label{
            margin-top: 8px;
        }
        .sureBtn{
            .el-button{
                padding: 10px 40px;
            }
            .el-button--primary{
                background-color: #409EFF;
                border-color: #409EFF;
            }
            .el-button--primary:hover{
                background-color: #409EFF;
                border-color: #409EFF;
            }
            .el-form-item__content {
                text-align: center;
                margin-left: 0!important;
            }
            .cancel{
                background-color: #fff!important;
                border: 1px solid #e5e5e5!important;
                color: #999;
                margin-right: 10px;
            }
        }
    }
</style>